import { render, staticRenderFns } from "./TournamentBeneficiariesView.vue?vue&type=template&id=7d1b0e1a&scoped=true"
import script from "./TournamentBeneficiariesView.vue?vue&type=script&lang=js"
export * from "./TournamentBeneficiariesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b0e1a",
  null
  
)

export default component.exports